import React from "react";
import { Card } from "react-bootstrap";
import { getLogo, getSalutation, getClosing } from "./helpers";

const TeamLeaderReport: React.FC = () => (
  <Card className="padding-20px raw-email-html">
    {getLogo()}
    <hr />
    <div className="sample-email-reports-body">
      {getSalutation("Jessica")}
      <p>
        Your team is making strong progress on critical HR initiatives despite
        managing heavy workloads across recruiting, benefits, and compliance.
        The most immediate need is addressing the recruiting system challenges
        that are creating bottlenecks for both Michael and Lisa. A focused
        intervention here will unlock significant productivity gains and reduce
        team stress.
      </p>
      <p>
        <strong>Team Response Overview:</strong>
      </p>
      <ul className="check-in-response-list">
        <li>
          <p>5 of 5 team members completed their weekly check-in</p>
        </li>
        <li>
          <p>
            All team members showing strong progress despite system challenges
          </p>
        </li>
        <li>
          <p>
            2 team members reporting lower energy due to workload and technical
            frustrations
          </p>
        </li>
        <li>
          <p>
            3 recurring themes: ATS limitations, benefits enrollment complexity,
            and cross-training needs
          </p>
        </li>
      </ul>
      <hr />
      <p>
        <strong>Priority Actions:</strong>
      </p>
      <p>
        <strong>1. IMMEDIATE (This Morning):</strong> Schedule vendor call
        regarding ATS performance issues affecting recruiting workflow
      </p>
      <ul className="check-in-response-list">
        <li>
          <p>
            <strong>Who:</strong> Sarah + Michael + Lisa + IT
          </p>
        </li>
        <li>
          <p>
            <strong>Impact:</strong> Resolves bottleneck affecting 40+ open
            requisitions and reduces manual workarounds
          </p>
        </li>
      </ul>
      <p>
        <strong>2. TODAY:</strong> Check in with Jennifer on benefits enrollment
        surge and overtime authorization
      </p>
      <ul className="check-in-response-list">
        <li>
          <p>
            <strong>Who:</strong> Sarah + Jennifer
          </p>
        </li>
        <li>
          <p>
            <strong>Impact:</strong> Ensures smooth open enrollment while
            preventing team burnout
          </p>
        </li>
      </ul>
      <p>
        <strong>3. THIS WEEK:</strong> Review cross-training plan with David to
        create backup coverage for critical functions
      </p>
      <ul className="check-in-response-list">
        <li>
          <p>
            <strong>Who:</strong> Sarah + David + Team
          </p>
        </li>
        <li>
          <p>
            <strong>Impact:</strong> Reduces single points of failure and
            enables better workload distribution
          </p>
        </li>
      </ul>
      <hr />
      <p>
        <strong>Individual Focus Areas:</strong>
      </p>
      <p>
        <strong>Michael Chen (Senior Recruiter)</strong>
      </p>
      <ul className="check-in-response-list">
        <li>
          <p>
            <strong>Focus:</strong> Engineering hiring surge and ATS workarounds
          </p>
        </li>
        <li>
          <p>
            <strong>Need:</strong> System improvements to handle high-volume
            recruiting
          </p>
        </li>
        <li>
          <p>
            <strong>Action:</strong> Prioritize ATS vendor escalation and
            explore temporary solutions
          </p>
        </li>
      </ul>
      <p>
        <strong>Lisa Thompson (Recruiting Coordinator)</strong>
      </p>
      <ul className="check-in-response-list">
        <li>
          <p>
            <strong>Focus:</strong> Candidate experience improvements while
            managing system limitations
          </p>
        </li>
        <li>
          <p>
            <strong>Need:</strong> Better tools for scheduling and communication
            automation
          </p>
        </li>
        <li>
          <p>
            <strong>Action:</strong> Identify quick wins to reduce manual
            coordination time
          </p>
        </li>
      </ul>
      <p>
        <strong>Jennifer Walsh (Benefits Manager)</strong>
      </p>
      <ul className="check-in-response-list">
        <li>
          <p>
            <strong>Focus:</strong> Open enrollment execution with 500+
            employees
          </p>
        </li>
        <li>
          <p>
            <strong>Need:</strong> Temporary support or overtime approval for
            peak period
          </p>
        </li>
        <li>
          <p>
            <strong>Action:</strong> Assess resource needs and authorize
            appropriate support
          </p>
        </li>
      </ul>
      <p>
        <strong>David Rodriguez (HR Generalist)</strong>
      </p>
      <ul className="check-in-response-list">
        <li>
          <p>
            <strong>Focus:</strong> Policy updates and compliance training
            rollout
          </p>
        </li>
        <li>
          <p>
            <strong>Need:</strong> Dedicated time blocks for deep work on
            documentation
          </p>
        </li>
        <li>
          <p>
            <strong>Action:</strong> Help protect focus time and delegate
            routine inquiries
          </p>
        </li>
      </ul>
      <p>
        <strong>Robert Kim (HRIS Analyst)</strong>
      </p>
      <ul className="check-in-response-list">
        <li>
          <p>
            <strong>Focus:</strong> Data migration project and reporting
            automation
          </p>
        </li>
        <li>
          <p>
            <strong>Need:</strong> Clear requirements from department heads
          </p>
        </li>
        <li>
          <p>
            <strong>Action:</strong> Facilitate requirements gathering session
            this week
          </p>
        </li>
      </ul>
      <hr />
      <p>
        <strong>Week Ahead:</strong>
      </p>
      <ul className="check-in-response-list">
        <li>
          <p>
            ATS performance issues creating cascading delays in hiring process
          </p>
        </li>
        <li>
          <p>
            Benefits enrollment deadline approaching with high volume expected
          </p>
        </li>
        <li>
          <p>
            Compliance training completion rates need monitoring (currently at
            67%)
          </p>
        </li>
        <li>
          <p>
            Recognition: Lisa's creative solutions for candidate communication
            during system outages showed exceptional initiative
          </p>
        </li>
      </ul>
      <hr />
      <p>
        Focus first on the technical bottlenecks – resolving the ATS issues will
        immediately improve team morale and productivity across your recruiting
        function.
      </p>
      {getClosing()}
    </div>
  </Card>
);

export default TeamLeaderReport;
